var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.6 37.44h28.8c2.4 0 3.6 1.2 3.6 3.6 0 2.4-1.2 3.6-3.6 3.6h-28.8c-2.4 0-3.6-1.2-3.6-3.6 0-2.4 1.2-3.6 3.6-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.91552 8.79672c.9372.9372.9372 2.45688 0 3.39408l-6.29568 6.29544 10.308 10.30824c1.44408 1.44384 1.44408 3.7848 0 5.22888-1.44384 1.44384-3.7848 1.44384-5.22864 0l-10.308-10.308-5.99664 5.9964c-.9372.93744-2.45688.93744-3.39408 0l-7.0632-7.0632c-.93744-.93744-.93744-2.45712 0-3.39432l17.52072-17.52096c.9372-.9372 2.45688-.9372 3.39408 0z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMint);
export default __webpack_public_path__ + "static/media/mint.9ebc1f8201eb61ff1d17fec962f7b51b.svg";
export { ForwardRef as ReactComponent };